import React from 'react';

export type BaseFormFieldProps = {
  id?: string;
  label?: string;
  helperText?: string;
  helperTextPlacement?: 'beforeControl' | 'afterControl';
  errorText?: string;
  isRequired?: boolean;
  showAsterisk?: boolean;
  invalid?: boolean;
};

export function useFormField(id?: string, helperText?: string, errorText?: string) {
  const generatedId = React.useId();
  const fieldId = id || generatedId;
  const helperId = helperText ? `${fieldId}-helper` : undefined;
  const errorId = errorText ? `${fieldId}-error` : undefined;
  const describedBy = [helperId, errorId].filter(Boolean).join(' ') || undefined;

  return {
    fieldId,
    helperId,
    errorId,
    describedBy,
  };
}
